module.exports = __webpack_public_path__ + "static/img/3.77a4e48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/eng/3.png
// module id = 2H7X
// module chunks = 0